export const isDragonstone = (requisitionId: string) => {
  return requisitionId.toLowerCase().startsWith("job");
};

export const isSalesforceApplication = (applicationId: string) => {
  return applicationId.length != 36 && applicationId.startsWith("a"); //Salesforce application id starts with a for auto-generated ids
};
